module.exports = __webpack_public_path__ + "static/media/2D.eaef1133.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2D.svg
// module id = 54
// module chunks = 0